import { render } from "./ValidatePopUp.vue?vue&type=template&id=5f936fbd&scoped=true"
import script from "./ValidatePopUp.vue?vue&type=script&lang=js"
export * from "./ValidatePopUp.vue?vue&type=script&lang=js"

import "./ValidatePopUp.vue?vue&type=style&index=0&id=5f936fbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f936fbd"]])

export default __exports__